import { Collections } from "Collections"
import { db, persistedDb } from "FirebaseConfigs"
import { FirebaseUtils } from "firebaseUtils/FirebaseUtils"
import { AnalyticsEvent } from "models/AnalyticsEvent"
import { AppUser } from "models/AppUser"
import { EnqueueSnacbar } from "models/EnqueueSnacbar"
import { Nullable } from "models/Nullable"
import { OrgUser } from "models/OrgUser"
import { PriceField } from "models/PriceField"
import { PriceFieldTemplate } from "models/PriceFieldTemplate"
import { WithoutId } from "models/WithoutId"
import { deleteField } from "Util/deleteField"

export function subscribeToTemplate(priceField: PriceField, appUser: AppUser, orgUser: Nullable<OrgUser>, template: PriceFieldTemplate, enqueueSnackbar: EnqueueSnacbar, contextEvent: AnalyticsEvent) {
    FirebaseUtils.updateDocument<PriceField>(
        true,
        Collections.PRICE_FIELDS,
        priceField.id,
        appUser,
        orgUser,
        AnalyticsEvent.SUBSCRIBED_PRICE_FIELD_TO_TEMPLATE,
        contextEvent,
        AnalyticsEvent.SUBSCRIBE_PRICE_FIELD_TO_TEMPLATE_ERROR,
        enqueueSnackbar,
        null,
        {
            template: {
                id: template.id,
            },
        },
    )
}

export function createTemplateId(persist: boolean, asSuggestion: boolean) {
    return (persist ? db : persistedDb).collection(!asSuggestion ? Collections.PRICE_FIELD_TEMPLATES : Collections.PRICE_FIELD_TEMPLATE_SUGGESTIONS).doc().id
}

export function templateFrom(templateId: string, priceField: PriceField | WithoutId<PriceField>): PriceFieldTemplate {
    return 'id' in priceField ? {
        id: templateId,
        template: {
            priceField: deleteField(priceField, 'id'),
        },
        original: {
            priceField: {
                id: priceField.id
            }
        },
    } : {
        id: templateId,
        template: {
            priceField,
        },
        original: null,
    }
}

export function createTemplate(appUser: AppUser, orgUser: Nullable<OrgUser>, template: PriceFieldTemplate, enqueueSnackbar: EnqueueSnacbar) {
    FirebaseUtils.createDocument<PriceFieldTemplate>(
        true,
        Collections.PRICE_FIELD_TEMPLATES,
        template.id,
        appUser,
        orgUser,
        AnalyticsEvent.CREATED_PRICE_FIELD_TEMPLATE,
        AnalyticsEvent.CREATED_PRICE_FIELD_TEMPLATE,
        AnalyticsEvent.CREATE_PRICE_FIELD_TEMPLATE_ERROR,
        enqueueSnackbar,
        'Mal opprettet',
        template,
    )
}
export function promoteTemplateSuggestion(appUser: AppUser, orgUser: Nullable<OrgUser>, template: PriceFieldTemplate, enqueueSnackbar: EnqueueSnacbar) {
    createTemplate(
        appUser,
        orgUser,
        template,
        enqueueSnackbar,
    )

    deleteTemplateSuggestion(
        appUser,
        orgUser,
        template,
        enqueueSnackbar,
        AnalyticsEvent.CREATED_PRICE_FIELD_TEMPLATE,
    )
}

export function deleteTemplateSuggestion(appUser: AppUser, orgUser: Nullable<OrgUser>, template: PriceFieldTemplate, enqueueSnackbar: EnqueueSnacbar, contextEvent: AnalyticsEvent) {
    FirebaseUtils.deleteDocument(
        true,
        Collections.PRICE_FIELD_TEMPLATE_SUGGESTIONS,
        template.id,
        appUser,
        orgUser,
        AnalyticsEvent.REMOVED_PRICE_FIELD_TEMPLATE_SUGGESTION,
        contextEvent,
        AnalyticsEvent.DELETE_PRICE_FIELD_TEMPLATE_SUGGESTION_ERROR,
        enqueueSnackbar,
        null,
        () => ({ appUserId: appUser?.id, }),
    )
}

export function createTemplateSuggestion(appUser: AppUser, orgUser: Nullable<OrgUser>, template: PriceFieldTemplate, enqueueSnackbar: EnqueueSnacbar) {
    FirebaseUtils.createDocument<PriceFieldTemplate>(
        true,
        Collections.PRICE_FIELD_TEMPLATE_SUGGESTIONS,
        template.id,
        appUser,
        orgUser,
        AnalyticsEvent.CREATED_PRICE_FIELD_TEMPLATE_SUGGESTION,
        AnalyticsEvent.CREATED_PRICE_FIELD_TEMPLATE_SUGGESTION,
        AnalyticsEvent.CREATE_PRICE_FIELD_TEMPLATE_SUGGESTION_ERROR,
        enqueueSnackbar,
        'Forslag sendt',
        template,
    )

}
